import { connect } from "react-redux";
import InspectionRequests from "./inspectionRequests";
import { bindActionCreators } from "redux";
import { viewAssigneeData} from "services/redux/maintenance/inspectionRequests/action";
import {
  viewSiteInspectionForms,
  listSiteInspectionManagers,
  changeSiteInspectionManager,
} from "services/redux/sales/postSaleListing/action";

const mapStateToProps = (state) => ({
    siteInspectionList: state.postSalesListReducer.siteInspectionList
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
        viewAssigneeData,
        viewSiteInspectionForms,
        listSiteInspectionManagers,
        changeSiteInspectionManager,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(InspectionRequests);
